import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Card, Row, Col } from "react-bootstrap";
import CustomTable from "../common/table";
import a3innuvaImg from '../../assets/a3innuva-nom.jpg';
import { CallWKAAuthServer, getAccessToken, getInnuvaCompanies } from "../../Services/authorizationInnuvaService";
import DropDown from "../common/customDropDown";
import FormCard from "../common/formCard";
import { GetUsersSelectService } from "../../Services/userService";
import CheckBox from "../common/customCheckBox";
import { useMemo } from "react";
import { PostCompanyService } from "../../Services/companyService";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const InnuvaCompaniesModal = ({ show, handleClose, textBody, onClickButton, companiesFromInnuva, companyApiResponseFromInnuvaModal }) => {
  const [t] = useTranslation("companies")
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [companiesFromInnuvaData, setCompaniesFromInnuvaData] = useState([]);
  const [view, setView] = useState('table');   // Estado para controlar la vista del componente 'table', 'all', 'individual'
  const [isCheckBoxSelected, setIsCheckBoxSelected] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [buttonConectDisabled, setButtonConnectDisabled] = useState(false);
  const [isResponsibleSelected, setIsResponsibleSelected] = useState(false);
  const [isResponsibleIndividualSelected, setIsResponsibleIndividualSelected] = useState(false);
  const [currentCompanyIndex, setCurrentCompanyIndex] = useState(0); // Estado para el índice de la empresa actual
  const [companiesFromAll, setCompaniesFromAll] = useState({});
  const [companiesFromIndividual, setCompaniesFromIndividual] = useState({});
  const [postCompanyResponse, setPostCompanyResponse] = useState({});

  useEffect(() => {
    const accessToken = sessionStorage.getItem('accessToken');
    if (accessToken && companiesFromInnuva) {
      setCompaniesFromInnuvaData(companiesFromInnuva);
      setButtonConnectDisabled(true);
      /*       if (!companiesFromInnuva) { //Revisar a futuro el loading interno de la tabla

              setLoading(true);
            } else {
              setLoading(false);
            } */
    } else {
      setButtonConnectDisabled(false);
      //setLoading(false);
    }
  }, [companiesFromInnuva]);

  const columnHeaders = [
    `${t("innuva.name")}`,
    `${t("innuva.nif")}`
  ];

  const fieldsToShow = [
    "name",
    "nifCif"
  ];

  const optionArrays = [
    []
  ];

  const closeModal = () => {
    handleClose();
    setView('table');
    setButtonDisabled(true);
    setIsCheckBoxSelected(false);
    setIsResponsibleSelected(false);
  }

  const goBack = (view) => {
    setView(view);
    setButtonDisabled(true);
    setIsCheckBoxSelected(false);
    if (view === 'all') {
      setIsResponsibleSelected(false); //Controlar cuando el responsable esta seleccionado dependiendo de la vista.
    }
  }

  const handleItemsSelected = (companies) => {
    setCompanies(companies);
  }

  const handleContinueClick = () => {

    if (view === 'table') {
      setView('all');
    } else {
      if (isCheckBoxSelected) {
        setView('individual');
      }
      else {
        setView('table');
      }

    }
  };

  const handleCheckBoxChange = (isSelected) => {
    setIsCheckBoxSelected(isSelected);
  };

  const handleResponsibleSelected = (isSelected) => {
    setIsResponsibleSelected(isSelected);
  }
  const handleResponsibleIndividualSelected = (isSelected) => {
    setIsResponsibleIndividualSelected(isSelected);
  }

  const handlePreviousClick = () => {
    if (view === 'individual') {
      if (currentCompanyIndex > 0) {
        setCurrentCompanyIndex(currentCompanyIndex - 1);
        // Acciones al retroceder a la empresa anterior
      } else {
        // Si es la primera empresa en vista individual, manejar como CANCELAR
        goBack('all');
        //closeModal();
      }
    }

    if (view === 'all') {
      goBack('table');
    }

    if (view === 'table') {
      closeModal();
    }



  };

  const handleNextOrFinishClick = () => {
    if (view === 'individual') {
      if (currentCompanyIndex < companies.length - 1) {
        setCurrentCompanyIndex(currentCompanyIndex + 1);
        // Acciones al avanzar a la próxima empresa
      } else {
        // Si es la última empresa en vista individual, manejar como FINALIZAR
        // Aquí, enviar los datos recopilados en companiesFromIndividual
        const promises = companiesFromIndividual.map(company => PostCompanyService(company));

        // Esperar a que todas las promesas se resuelvan
        Promise.all(promises).then(apiResponses => {
          // apiResponses es ahora un array de resultados de todas las llamadas asincrónicas
          const apiResponseArrayIndividual = apiResponses.map((apiResponse, index) => {
            return { apiResponse, company: companiesFromIndividual[index] };
          });

          // Ahora puedes pasar apiResponseArrayAll porque las promesas se han resuelto
          companyApiResponseFromInnuvaModal(apiResponseArrayIndividual);
          closeModal();
        }).catch(error => {
          // Manejar cualquier error que ocurra durante las llamadas asincrónicas
          console.error('Error in PostCompanyService calls', error);
        });
      }
    } if (view === 'all' && isResponsibleSelected) {

      // Crear un array de promesas usando map en lugar de forEach
      const promises = companiesFromAll.map(company => PostCompanyService(company));

      // Esperar a que todas las promesas se resuelvan
      Promise.all(promises).then(apiResponses => {
        // apiResponses es ahora un array de resultados de todas las llamadas asincrónicas
        const apiResponseArrayAll = apiResponses.map((apiResponse, index) => {
          return { apiResponse, company: companiesFromAll[index] };
        });

        // Ahora puedes pasar apiResponseArrayAll porque las promesas se han resuelto
        companyApiResponseFromInnuvaModal(apiResponseArrayAll);
        closeModal();
      }).catch(error => {
        // Manejar cualquier error que ocurra durante las llamadas asincrónicas
        console.error('Error in PostCompanyService calls', error);
      });
    } else {
      handleContinueClick(); // En otras vistas, manejar como antes
    }
  };

  const handleCompaniesFromAll = (data) => {
    setCompaniesFromAll(data);
  }

  const handleCompaniesFromIndividual = (updatedCompanies) => {
    setCompaniesFromIndividual(updatedCompanies);
  };


  useEffect(() => {
    let shouldDisable = false;

    if (view === 'table' && companies.length === 0) {
      shouldDisable = true;
    } else if (view === 'all') {
      // Aquí consideramos tanto el estado del checkbox como si un responsable ha sido seleccionado
      if (!isCheckBoxSelected && !isResponsibleSelected) {
        shouldDisable = true;
      }
    } else if (view === 'individual' && !isResponsibleIndividualSelected) {
      shouldDisable = true;
    }

    setButtonDisabled(shouldDisable);
  }, [view, companies, isCheckBoxSelected, isResponsibleSelected, isResponsibleIndividualSelected]);


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="popup-after-action-modal-body modal-body-big">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <div style={{ width: "100%", margin: "0 auto" }}>

                  {view === 'all' || view === 'individual' ? (
                    <Button
                      variant="none"
                      className="modal-close-button"
                      onClick={closeModal}
                    >
                      <FaTimes className="mb-1" />
                    </Button>
                  ) : null}
                  {/* Renderizado condicional de los componentes */}
                  {view === 'table' && (
                    <>
                      <div className="d-flex justify-content-around">
                        <img
                          src={a3innuvaImg}
                          alt="a3innuvaImg"
                          className="innuva-logo"
                        />
                        <div className="align-items-center">
                          <p className="modal-title mt-2 text-center connect-text">
                            {t("innuva.explainText")}
                          </p>
                        </div>
                        <Button
                          variant="success"
                          className="custom-button-primary connect-button"
                          onClick={CallWKAAuthServer}
                          disabled={buttonConectDisabled}
                        //disabled={!isFormValid}
                        >
                          {t("innuva.connect")}
                        </Button>
                      </div>
                      <CustomTable
                        columnHeaders={columnHeaders}
                        fieldsToShow={fieldsToShow}
                        data={companiesFromInnuvaData}
                        optionArrays={optionArrays}
                        defaultFilterField={'createdAt'}
                        defaultFilterDirection={'desc'}
                        //loading={loading}
                        editButton={false}
                        displayFilter={false}
                        displayCheckBoxSelector
                        onSelectedItems={handleItemsSelected}
                        selectedCompaniesInnuvaModal={companies}
                        itemsNumber={5}
                        hideItemsNumber={true}
                        displayCompaniesCounter={true}
                        innuvaImportTable
                      />
                    </>
                  )}

                  {view === 'all' &&
                    <InnuvaResponsibleAll companies={companies} onCheckBoxChange={handleCheckBoxChange} responsibleSelected={handleResponsibleSelected} onCompaniesFromAllChange={handleCompaniesFromAll}
                      t={t}
                    />
                  }

                  {view === 'individual' &&
                    <InnuvaResponsibleIndividual companies={companies} currentCompanyIndex={currentCompanyIndex} onCompaniesFromIndividualChange={handleCompaniesFromIndividual} onResponsibleIndividualSelection={handleResponsibleIndividualSelected}
                      t={t}
                    />
                  }

                  <div className={`d-flex ${view === 'individual' ? 'justify-content-end' : 'justify-content-around'}  mt-4 align-items-center`}>
                    <Button
                      variant="secondary"
                      className="custom-button-secondary"
                      onClick={handlePreviousClick}
                    >
                      {view === 'individual' && currentCompanyIndex !== 0 ?
                        `${t("innuva.prev")}` : view === "all" ?
                          `${t("innuva.back")}` : view === "table" ?
                            `${t("innuva.cancel")}` : `${t("innuva.back")}`
                      }
                    </Button>

                    {/* Renderizado condicional del texto dinámico solo para la vista individual */}
                    {view === 'individual' && (
                      <span className="mx-3">{`${currentCompanyIndex + 1} de ${companies.length}`}</span>
                    )}

                    <Button
                      variant="success"
                      className="custom-button-primary"
                      onClick={handleNextOrFinishClick}
                      disabled={buttonDisabled}
                    >
                      {/* Renderizado condicional del texto del botón */}
                      {view === 'individual'
                        ? currentCompanyIndex === companies.length - 1
                          ? `${t("innuva.end")}`
                          : `${t("innuva.next")}`
                        : view === 'table'
                          ? `${t("innuva.select")}`
                          : `${t("innuva.continue")}`
                      }
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export const InnuvaResponsibleAll = ({ companies, onCheckBoxChange, responsibleSelected, onCompaniesFromAllChange, t }) => {

  const [selectResponsibleData, setSelectResponsibleData] = useState(
    {
      responsibleFullNameNIF: '',
      responsibleId: ''
    }
  );

  const [optionsResponsible, setOptionsResponsible] = useState([]);
  const [checkBool, setCheckBool] = useState(false);

  const handleInputChange = (label, value) => {
    const newResponsibleData = {
      responsibleFullNameNIF: label,
      responsibleId: value
    };
    setSelectResponsibleData(newResponsibleData);

    if (label && value) {
      responsibleSelected(true);
      // Asigna el responsable seleccionado a todas las empresas seleccionadas
      const updatedCompanies = companies.map(company => ({
        ...company,
        responsibleId: value
      }));
      onCompaniesFromAllChange(updatedCompanies); // Envía los datos actualizados al padre
    }
  }

  // Maneja el cambio en la selección del checkbox
  const handleCheck = (check) => {
    setCheckBool(check);
    onCheckBoxChange(check);

    // Actualiza el estado del padre con datos vacíos si se elige la opción individual
    if (check) {
      responsibleSelected(false);
      setSelectResponsibleData({});
      onCompaniesFromAllChange({}); // Envía datos vacíos al padre
    }
  }


  useEffect(() => {
    const fetchDataResponsibleOptions = async () => {
      try {
        const result = await GetUsersSelectService();
        const formattedData = result
          .filter((data) => data.user !== selectResponsibleData.responsibleId)
          .map((data) => ({
            label: `${data.name} ${data.surname} (${data.nif})`,
            value: data.user,
          }));

        setOptionsResponsible(formattedData);

      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchDataResponsibleOptions();
  }, [selectResponsibleData]);

  return (
    <>
      <p>{t("innuvaForm.selectResponsibleAll")}</p>
      {checkBool ?
        <FormCard
          title={t("innuvaForm.responsible")}
          type={"select"}
          options={optionsResponsible}
          readOnly
        /> :
        <FormCard
          title={t("innuvaForm.responsible")}
          type={"select"}
          selectedValue={{
            label: selectResponsibleData.responsibleFullNameNIF,
            value: selectResponsibleData.responsibleId,
          }}
          options={optionsResponsible}
          onChange={(e) =>
            handleInputChange(
              e.label,
              e.value
            )
          }
        />
      }


      <CheckBox
        text={t("innuvaForm.selectResponsibleIndividually")}
        onChange={handleCheck}
      />
    </>
  );
};


export const InnuvaResponsibleIndividual = ({ companies, currentCompanyIndex, onCompaniesFromIndividualChange, onResponsibleIndividualSelection, t }) => {


  // Esto forzará la re-renderización cada vez que el índice cambie
  const key = useMemo(() => Math.random(), [currentCompanyIndex]);

  // Inicializar el estado con una función para obtener el valor actualizado
  const [selectResponsibleData, setSelectResponsibleData] = useState(() => ({
    responsibleFullNameNIF: companies[currentCompanyIndex]?.responsibleFullNameNIF || '',
    responsibleId: companies[currentCompanyIndex]?.responsibleId || '',
  }));

  const [optionsResponsible, setOptionsResponsible] = useState([]);

  const handleInputChange = (label, value) => {
    setSelectResponsibleData({
      responsibleFullNameNIF: label,
      responsibleId: value
    });
  }

  useEffect(() => {
    const fetchDataResponsibleOptions = async () => {
      try {
        const result = await GetUsersSelectService();
        const formattedData = result
          .filter((data) => data.user !== selectResponsibleData.responsibleId)
          .map((data) => ({
            label: `${data.name} ${data.surname} (${data.nif})`,
            value: data.user,
          }));

        setOptionsResponsible(formattedData);

      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchDataResponsibleOptions();
  }, [selectResponsibleData]);

  useEffect(() => {
    // Esta función debería ejecutarse cada vez que cambie el índice y las empresas
    setSelectResponsibleData({
      responsibleFullNameNIF: companies[currentCompanyIndex]?.responsibleFullNameNIF || '',
      responsibleId: companies[currentCompanyIndex]?.responsibleId || ''
    });

    // ...
  }, [currentCompanyIndex, companies]);

  useEffect(() => {
    // Esta función debería ejecutarse cada vez que cambie el índice y las empresasR
    companies[currentCompanyIndex].responsibleId = selectResponsibleData.responsibleId;
    companies[currentCompanyIndex].responsibleFullNameNIF = selectResponsibleData.responsibleFullNameNIF;
    onCompaniesFromIndividualChange(companies);
    // ...
  }, [selectResponsibleData]);

  useEffect(() => {
    const isResponsibleSelectedBool = selectResponsibleData.responsibleId !== '';
    onResponsibleIndividualSelection(isResponsibleSelectedBool);
  }, [selectResponsibleData.responsibleId, onResponsibleIndividualSelection]);


  return (
    <React.Fragment key={key}>
      <Row >
        <Col md={6} >
          <FormCard
            title={t("innuvaForm.nif")}
            type={"text"}
            text={companies[currentCompanyIndex].nifCif}
            readOnly={true}
          />
        </Col>
        <Col md={6} >

          <FormCard
            title={t("innuvaForm.name")}
            type={"text"}
            text={companies[currentCompanyIndex].name}
            readOnly={true}
          />
        </Col>
      </Row>
      <Row key={key}>
        <Col md={6} >
          <FormCard
            title={t("innuvaForm.responsible")}
            type={"select"}
            selectedValue={{
              label: companies[currentCompanyIndex].responsibleFullNameNIF, // Actualiza esta línea según tus datos
              value: companies[currentCompanyIndex].responsibleId, // Actualiza esta línea según tus datos
            }}
            options={optionsResponsible}
            onChange={(e) =>
              handleInputChange(
                e.label,
                e.value
              )
            }
          />
        </Col>
      </Row>
    </React.Fragment>
  );

};